import Cookies from "js-cookie";

export function bool(key: string) {
  return Cookies.get(key) === "true";
}

export function string(key: string) {
  return "" + (Cookies.get(key) || "");
}

export const get = Cookies.get;

export const set = Cookies.set;

export const remove = Cookies.remove;
